import Vue from 'vue';
import {
  EVENTS, EVENT_ATTRIBUTES, TrackEvent
} from '../services/track-event.service';

Vue.directive('trackevent', {
  bind(el, binding) {
    let rolloverTimer;
    const val = binding.arg === 'val' ? binding.value : '';

    el.onclick = function () {
      if (el.href && el.target === '_blank') {
        TrackEvent.record(EVENTS.Click, EVENT_ATTRIBUTES.Click.URL, el.href, val);
      } else {
        TrackEvent.record(EVENTS.Click, EVENT_ATTRIBUTES.Click.Actions, val, val);
      }
    };

    el.onmouseenter = function () {
      rolloverTimer = setTimeout(() => {
        if (el.href && el.target === '_blank') {
          TrackEvent.record(EVENTS.Hover, EVENT_ATTRIBUTES.Hover.Hover, el.href, val);
        } else {
          TrackEvent.record(EVENTS.Hover, EVENT_ATTRIBUTES.Hover.Actions, val, val);
        }
      }, 300);
    };

    el.onmouseleave = function () {
      clearTimeout(rolloverTimer);
    };
  }
});
